import styled from 'styled-components'

import { Colors } from '@fourthwall/components'

import type { VirtualProductThumbnailProps } from './types'

type ContainerProps = Pick<VirtualProductThumbnailProps, 'size'>

const getContainerFontSize = ({ size }: ContainerProps) => {
  if (size === 'small') {
    return 20
  }
  if (size === 'medium') {
    return 24
  }
  if (size === 'large') {
    return 28
  }
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: ${Colors.GS200};
  font-size: ${getContainerFontSize}px;
  color: ${Colors.GS1000};
  user-select: none;
  aspect-ratio: 3 / 4;
`
